var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "curr-month-overview" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "title-1", staticStyle: { margin: "20px 0 15px" } },
        [_vm._v(_vm._s(_vm.formatMonth) + "月全校提醒总数及构成情况")]
      ),
      _c("div", { staticClass: "overview-list flex-between" }, [
        _c("div", { staticClass: "overview-list-item" }, [
          _vm._m(1),
          _c(
            "div",
            { staticStyle: { transform: "translateY(-15px)" } },
            [
              _c("CountAnimation", {
                staticClass: "count-bold",
                attrs: { "end-val": _vm.cardInfo.remindStudentCount },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "overview-list-item" }, [
          _vm._m(2),
          _c(
            "div",
            { staticStyle: { transform: "translateY(-15px)" } },
            [
              _c("CountAnimation", {
                staticClass: "count-bold",
                attrs: { "end-val": _vm.cardInfo.twoRemindStudentCount },
              }),
              _vm._v("\n        人\n      "),
            ],
            1
          ),
          _c("div", [
            _vm._v("\n        占总提醒\n        "),
            _c("span", { staticStyle: { color: "#ff4646" } }, [
              _vm._v(_vm._s(_vm.cardInfo.twoRemindStudentRate) + "%"),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "overview-list-item" }, [
          _vm._m(3),
          _c(
            "div",
            { staticStyle: { transform: "translateY(-15px)" } },
            [
              _c("CountAnimation", {
                staticClass: "count-bold",
                attrs: { "end-val": _vm.cardInfo.threeRemindStudentCount },
              }),
              _vm._v("\n        名\n      "),
            ],
            1
          ),
          _c("div", [
            _vm._v("\n        占总提醒\n        "),
            _c("span", { staticStyle: { color: "#ff4646" } }, [
              _vm._v(_vm._s(_vm.cardInfo.threeRemindStudentRate) + "%"),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "overview-list-item" }, [
          _vm._m(4),
          _c(
            "div",
            { staticStyle: { transform: "translateY(-15px)" } },
            [
              _c("CountAnimation", {
                staticClass: "count-bold",
                attrs: { "end-val": _vm.cardInfo.careStudentRemindCount },
              }),
              _vm._v("\n        次\n      "),
            ],
            1
          ),
          _c("div", [
            _vm._v("\n        占总提醒\n        "),
            _c("span", { staticStyle: { color: "#ff4646" } }, [
              _vm._v(_vm._s(_vm.cardInfo.careStudentRemindRate) + "%"),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "flex-between", staticStyle: { "margin-top": "15px" } },
        [
          _c("div", { staticClass: "title-1" }, [
            _vm._v("重点学生班主任关怀情况"),
          ]),
          _c(
            "div",
            {
              staticStyle: { color: "#2a82e4", cursor: "pointer" },
              on: { click: _vm.viewModal },
            },
            [
              _vm._v("\n      查看详情\n      "),
              _c("a-icon", { attrs: { type: "right" } }),
            ],
            1
          ),
        ]
      ),
      _c("TableList", {
        staticStyle: { width: "100%" },
        attrs: {
          columns: _vm.columns,
          tableData: _vm.dataSource,
          loading: _vm.loading,
          scroll: {},
        },
      }),
      _vm._m(5),
      _c("DetailModal", {
        ref: "detailModalRef",
        attrs: {
          title: "重点学生班主任关怀情况",
          columns: _vm.columns,
          url: _vm.url,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex-align-center" }, [
      _c("img", {
        staticStyle: { width: "20px", height: "20px", "margin-right": "5px" },
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/characterLine.png"),
          alt: "",
        },
      }),
      _c("div", { staticClass: "record-title" }, [_vm._v("重点学生管理")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-title" }, [
      _c("div", [_vm._v("提醒总数")]),
      _c("img", {
        staticClass: "item-icon",
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/smallBellCircle.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-title" }, [
      _c("div", [_vm._v("两次提醒")]),
      _c("img", {
        staticClass: "item-icon",
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/moreTwiceCircle.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-title" }, [
      _c("div", [_vm._v("三次及以上提醒")]),
      _c("img", {
        staticClass: "item-icon",
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/moreThreeTimes.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-title" }, [
      _c("div", [_vm._v("关爱名单提醒")]),
      _c("img", {
        staticClass: "item-icon",
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/loveRedCircle.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tip" }, [
      _c("span", [
        _c("img", {
          staticStyle: { width: "14px", height: "14px", "margin-right": "5px" },
          attrs: {
            src: require("@/assets/imgs/school/monthRecord/analyse.png"),
            alt: "",
          },
        }),
        _vm._v(
          "\n      关爱名单学生需建立个性化关怀档案,记录关怀过程、学生反馈及情绪变化趋势。对于同时属于多次提醒名单的学生,需启动二级干预机制,每周至少1次专项关怀。\n    "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }